import { render, staticRenderFns } from "./OnboardingCameraErrorIos.vue?vue&type=template&id=10e87cb9&scoped=true"
import script from "./OnboardingCameraErrorIos.vue?vue&type=script&lang=js"
export * from "./OnboardingCameraErrorIos.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCameraErrorIos.vue?vue&type=style&index=0&id=10e87cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e87cb9",
  null
  
)

export default component.exports